import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import ButtonIcon from '../button-icon';

/* eslint-disable-next-line  import/no-self-import */
import TaxonomyClassificationChildren from './taxonomy-classification';
import TaxonomyBadge from './taxonomy-badge';

const TaxonomyClassification = ({
	classification,
	handleClassificationClick,
	expanded,
	selectedClassification = null,
}) => {
	const [isOpen, setIsOpen] = useState(expanded);

	useEffect(() => {
		setIsOpen(expanded);
	}, [expanded]);

	return (
		<div>
			{classification && (
				<>
					<div className="flex-row padding-4">
						<div className="taxonomy-tree__node-expand-button">
							{classification.children?.length ? (
								<ButtonIcon
									icon={isOpen ? 'minus' : 'plus'}
									isSmall
									onClick={() => setIsOpen(!isOpen)}
								/>
							) : null}
						</div>
						<div
							className={`taxonomy-tree__node-label ${selectedClassification === classification.id ? 'font-weight-bold' : ''}`}
							role="presentation"
							onClick={() => handleClassificationClick(
								classification.label,
								classification.id,
							)}
						>
							{classification.label}
						</div>
						<div className="taxonomy-tree__node-badges flex-row justify-flex-start">
							{classification.aggSpecificationCount > 0 ? (
								<TaxonomyBadge type="spec" value={classification.aggSpecificationCount} />
							) : null}
							{classification.aggBundleCount > 0 ? (
								<TaxonomyBadge type="bundle" value={classification.aggBundleCount} />
							) : null}
						</div>
					</div>
					{(isOpen && classification.children?.length) ? (
						<div className="padding-left-40">
							{classification.children.map((classificationChild, index) => (
								<TaxonomyClassificationChildren
									// eslint-disable-next-line react/no-array-index-key
									key={index}
									classification={classificationChild}
									handleClassificationClick={handleClassificationClick}
									expanded={expanded}
									selectedClassification={selectedClassification}
								/>
							))}
						</div>
					) : null}
				</>
			)}
		</div>
	);
};

export default TaxonomyClassification;

TaxonomyClassification.propTypes = {
	classification: PropTypes.shape({
		taxonomyID: PropTypes.string.isRequired,
		id: PropTypes.number.isRequired,
		label: PropTypes.string.isRequired,
		children: PropTypes.arrayOf(PropTypes.shape({
			label: PropTypes.string.isRequired,
			id: PropTypes.number.isRequired,
		})).isRequired,
		aggSpecificationCount: PropTypes.number.isRequired,
		aggBundleCount: PropTypes.number.isRequired,
	}).isRequired,
	selectedClassification: PropTypes.number,
	handleClassificationClick: PropTypes.func.isRequired,
	expanded: PropTypes.bool.isRequired,
};
